import React from 'react';
import { LucideIcon, TrendingUp, TrendingDown } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  iconColor: string;
  iconBg: string;
  trend?: number;
  trendLabel?: string;
}

export default function StatCard({ title, value, icon: Icon, iconColor, iconBg, trend, trendLabel }: StatCardProps) {
  const isPositive = trend !== undefined && trend >= 0;

  return (
    <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 16, minHeight: 118, position: 'relative', overflow: 'hidden' }}>
      <div style={{
        position: 'absolute',
        inset: 'auto -42px -58px auto',
        width: 118,
        height: 118,
        borderRadius: '50%',
        background: iconBg,
        opacity: 0.44,
      }} />
      <div style={{
        width: 52, height: 52,
        borderRadius: 14,
        background: iconBg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
        boxShadow: `0 12px 24px ${iconBg}`,
        position: 'relative',
      }}>
        <Icon size={22} color={iconColor} strokeWidth={2} />
      </div>
      <div style={{ flex: 1, position: 'relative' }}>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 700, marginBottom: 7, letterSpacing: '0.02em' }}>{title}</div>
        <div style={{ fontSize: 26, fontWeight: 850, color: 'var(--text-primary)', lineHeight: 1, letterSpacing: '-0.04em' }}>{value}</div>
        {trend !== undefined && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 4,
            marginTop: 6, fontSize: 12,
            color: isPositive ? 'var(--success)' : 'var(--danger)',
            fontWeight: 600,
          }}>
            {isPositive ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
            <span>{Math.abs(trend)}% {trendLabel ?? 'vs last week'}</span>
          </div>
        )}
      </div>
    </div>
  );
}
